// styles
import { Wrapper, Container } from './style';

// interface
interface IProps {
  className?: string;
  children?: any;
  HTML?: any;
}

export function WarningMessage({ className, children, HTML }: IProps) {
  return (
    <Wrapper className={className}>
      {children ? (
        <Container>{children}</Container>
      ) : HTML ? (
        <Container dangerouslySetInnerHTML={{ __html: HTML }} />
      ) : (
        ''
      )}
    </Wrapper>
  );
}

export default WarningMessage;
